import { Duration } from 'luxon';

import { TimeIntervalInputUnit } from 'dashboard/components-lib/DurationInput/constants';

export const convertTimeToDesiredUnit = (
  timeInput: number | undefined | null,
  timeUnit: TimeIntervalInputUnit,
  desiredTimeUnit: 'days' | 'seconds' | 'years',
): number | undefined => {
  if (timeInput == null) {
    return undefined;
  }

  return Duration.fromObject({ [timeUnit]: timeInput }).as(desiredTimeUnit);
};
